import HTTPClient from './HTTPClient';

export default HTTPClient;
